export function mutateQuillHtmlValueForTranscribing(htmlValue: string) {
    const searchString = '<p><br></p>';
    if (htmlValue.endsWith(searchString)) {
        return htmlValue.substring(0, htmlValue.length - searchString.length);
    } else if (htmlValue.endsWith('</p>')) {
        return htmlValue.substring(0, htmlValue.length - 4);
    }

    return htmlValue;
}

export function doesKeyCancelTranscribe(key: string) {
    return key === 'Backspace' || key === 'Enter';
}
